export class Grid {
  constructor(left, top, right, height) {
    this.top = top
    this.left = left
    this.right = right
    this.bottom = height
    this.containLabel = false
    this.mode = "默认" //边框宽度，默认表示不可以设置边框宽度，自定义则可以设置
    this.edgeType = "global" //自定义边框类型，global表示设置一次，上下左右的padding都变，single表示单个设置
    this.init(arguments)
  }
  init(args) {
    this.checkArgs(args)
  }
  checkArgs(args) {
    const argNameArr = Grid.toString()
      .match(/\((.+?)\)/g)[0]
      .slice(1, -1)
      .replace(/\s+/g, "")
      .split(",")
    for (let i = 0; i < argNameArr.length; i++) {
      if (typeof args[i] === "undefined" && argNameArr[i] !== "options") {
        throw new Error("the argument '" + argNameArr[i] + "' from class Grid is undefined,please check this argument")
      }
    }
  }
}
